import { useContext } from "react";
import { GroupRecencyContext } from "contexts";

export default () => useContext(GroupRecencyContext);
